import { CancelToken } from 'axios';

import { GetReportsQuerySort } from '../reports';
import { AreaOfLearning, AssessmentForReport, AssessmentMethod } from './assessments';
import { IColumnSort } from './endpoints/people';
import { SchoolProperty } from './schools';
import { UserFilter } from './users';
import { EntryCreator } from '../generated/schooly-api-v2';

export interface ReportBase {
  id: string;
  name: string;
}

export interface Report extends ReportBase {
  report_status?: ReportStatuses;
  scheduled_publish_date?: string;
  actual_publish_date?: string;
  creator: EntryCreator;
  assessments?: AssessmentForReport[];
}

export type ReportAreaOfLearning = {
  id?: string;
  assessment_id?: string;
  methods: AssessmentMethod[];
} & Omit<AreaOfLearning, 'id'>;

export interface ReportForAssessment extends ReportBase {
  scheduled_publish_date?: string;
  actual_publish_date?: string;
  report_status: ReportStatuses;
  areas_of_learning: ReportAreaOfLearning[];
  age_groups: Pick<SchoolProperty, 'name' | 'id'>[];
  subjects: Pick<SchoolProperty, 'name' | 'id'>[];
  with_tutor_feedback: boolean;
  assessments: AssessmentForReport[];
}

export interface ReportUpdate {
  name: string;
  scheduled_publish_date: string;
  assessment_ids: string[];
}

export enum ReportStatuses {
  Published,
  Unpublished,
  Draft,
}

export interface ListReportsForSchool {
  filters?: Partial<UserFilter>;
  page_number?: number;
  page_size?: number;
  school_id: string;
  sort?: GetReportsQuerySort[];
  query?: string;
}

export interface ListReportsForRelation {
  relationId: string;
  dateFrom?: string;
  dateTo?: string;
  query?: string;
  sort?: IColumnSort<keyof Report | 'report_date'>[];
  token?: CancelToken;
}

export enum ReportAction {
  Publish = 'publish',
  Unpublish = 'unpublish',
}
